export const roomOptions = ["101", "102", "103", "201", "202", "203"];
export const wardOptions = ['Ward 1', 'Ward 2', 'ICU', 'Recovery'];
export const anesthesiologistOptions = ['Dr. A Kumar', 'Dr. B Sharma', 'Dr. C Patel'];
export const procedureOptions = ['Appendectomy', 'Hernia Repair', 'Cataract Surgery'];
export const preoperativeOptions = ['Paracetamol', 'NSAIDs', 'None'];
export const intraoperativeOptions = ['Regional block', 'IV opioids', 'Local infiltration'];
export const postoperativeOptions = ['Tramadol', 'Paracetamol', 'Morphine'];
export const nurseOptions = ['Nurse Alice', 'Nurse Bob', 'Nurse Charlie'];

export const columns = [
  "Time (Hours)",
  "Pulse Rate",
  "Blood Pressure",
  "Respiratory Rate",
  "Oxygen Saturation",
  "VAS Pain Score",
  "Sedation Level",
  "Rescue Analgesia",
  "Staff Nurse"
];
